// @flow

import React from 'react';

import styles from './styles.scss';

import { Item } from '../../components';

import type { AttributeType } from '../../api/types';

type Props = {
  items: Array<AttributeType>,
  studioInternalName: String,
};

const getLink = () => {
  return `${process.env.REACT_APP_API_HOST.replace(/api\/v\d+\//, '')}assets/files/CenterStagingLA campus.pdf`;
};

const Specifications = (props: Props) => (
  <div id="specifications" className={styles.specifications}>
    <h2>Specifications</h2>
    <div className="items">
      {props.items.map(item => (
        <Item key={item.name} name={item.name} value={item.value} />
      ))}
    </div>
    {props.studioInternalName === 'studio-1' && (
      <a target="_blank" className={styles.campusMapLink} href={getLink()}>
        Download Campus Map
      </a>
    )}
  </div>
);

export default Specifications;



// WEBPACK FOOTER //
// ./src/pages/Studios/Specifications.js